'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _every2 = require('lodash/every');

var _every3 = _interopRequireDefault(_every2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _reactI18next = require('react-i18next');

var _index = require('components/index');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _projects = require('selectors/projects');

var _datetime = require('helpers/datetime');

var _ProjectRecipientsListItem = require('components/Recipients/ProjectRecipientsList/ProjectRecipientsListItem');

var _ProjectRecipientsListItem2 = _interopRequireDefault(_ProjectRecipientsListItem);

var _ProjectRecipientsListGroupItem = require('components/Recipients/ProjectRecipientsList/ProjectRecipientsListGroupItem');

var _ProjectRecipientsListGroupItem2 = _interopRequireDefault(_ProjectRecipientsListGroupItem);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _Checkbox = require('components/Checkbox/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./ProjectRecipientsList.scss');

var ProjectRecipientsList = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    deleteRecipientActionData: state.project.deleteRecipientActionData,
    deleteRecipientLoading: state.project.deleteRecipientLoading,
    deleteRecipientsGroupActionData: state.project.deleteRecipientsGroupActionData,
    deleteRecipientsGroupLoading: state.project.deleteRecipientsGroupLoading,
    loadingEditRecipient: state.project.loadingEditRecipient,
    recipientsGroupedList: (0, _projects.getGroupedRecipients)(state),
    recipientsList: (0, _projects.getRecipients)(state),
    recipientsListLoading: state.project.recipientsListLoading,
    setRecipientsDownloadLoading: state.project.setRecipientsDownloadLoading
  };
}, (0, _extends4.default)({}, projectActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ProjectRecipientsList, _Component);

  function ProjectRecipientsList() {
    var _ref;

    (0, _classCallCheck3.default)(this, ProjectRecipientsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ProjectRecipientsList.__proto__ || (0, _getPrototypeOf2.default)(ProjectRecipientsList)).call.apply(_ref, [this].concat(args)));

    _this.state = { groupCollapsers: {}, allSelected: false };
    return _this;
  }

  (0, _createClass3.default)(ProjectRecipientsList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var recipientsList = nextProps.recipientsList;

      if (recipientsList !== this.props.recipientsList) {
        this.checkAllSelected(recipientsList);
      }
    }
  }, {
    key: 'checkAllSelected',
    value: function checkAllSelected() {
      var recipientsList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.recipientsList;

      var allSelected = !!recipientsList.length && (0, _every3.default)(recipientsList, 'download');
      this.setState({ allSelected: allSelected });
    }
  }, {
    key: 'toggleSelectAll',
    value: function toggleSelectAll(e) {
      var _props = this.props,
          setRecipientsDownload = _props.setRecipientsDownload,
          projectId = _props.projectId;

      var download = e.target.checked;
      setRecipientsDownload({ projectId: projectId, download: download });
    }
  }, {
    key: 'deleteRecipient',
    value: function deleteRecipient(recipient) {
      var _props2 = this.props,
          projectId = _props2.projectId,
          deleteRecipient = _props2.deleteRecipient,
          t = _props2.t;

      var toastrConfirmOptions = {
        onOk: function onOk() {
          return deleteRecipient(projectId, recipient.recipientId);
        },
        onCancel: function onCancel() {}
      };
      _toastr2.default.confirm(t('Are you sure you want to delete this recipient?'), toastrConfirmOptions);
    }
  }, {
    key: 'deleteGroup',
    value: function deleteGroup(group) {
      var _props3 = this.props,
          projectId = _props3.projectId,
          deleteRecipientsGroup = _props3.deleteRecipientsGroup,
          t = _props3.t;

      var toastrConfirmOptions = {
        onOk: function onOk() {
          return deleteRecipientsGroup(projectId, group.groupId);
        },
        onCancel: function onCancel() {}
      };
      _toastr2.default.confirm(t('Are you sure you want to delete this group?'), toastrConfirmOptions);
    }
  }, {
    key: 'updateRecipient',
    value: function updateRecipient(recipientId, data) {
      var _props4 = this.props,
          editRecipient = _props4.editRecipient,
          projectId = _props4.projectId;

      editRecipient(projectId, recipientId, data);
    }
  }, {
    key: 'updateRecipientDownload',
    value: function updateRecipientDownload(_ref2) {
      var recipient = _ref2.recipient,
          value = _ref2.value;

      this.updateRecipient(recipient.recipientId, { download: value ? 1 : 0 });
    }
  }, {
    key: 'updateRecipientExpirationDate',
    value: function updateRecipientExpirationDate(_ref3) {
      var recipient = _ref3.recipient,
          value = _ref3.value;

      this.updateRecipient(recipient.recipientId, { expirationDate: value.format(_datetime.dateFormat.sql) });
    }
  }, {
    key: 'toggleGroup',
    value: function toggleGroup(group) {
      this.setState({ groupCollapsers: (0, _extends4.default)({}, this.state.groupCollapsers, (0, _defineProperty3.default)({}, group.groupId, !this.state.groupCollapsers[group.groupId])) });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props5 = this.props,
          t = _props5.t,
          deleteRecipientLoading = _props5.deleteRecipientLoading,
          deleteRecipientActionData = _props5.deleteRecipientActionData,
          recipientsListLoading = _props5.recipientsListLoading,
          downloadAuthorised = _props5.downloadAuthorised,
          individualExpiryDate = _props5.individualExpiryDate,
          loadingEditRecipient = _props5.loadingEditRecipient,
          className = _props5.className,
          hideEmpty = _props5.hideEmpty,
          recipientsGroupedList = _props5.recipientsGroupedList,
          deleteRecipientsGroupLoading = _props5.deleteRecipientsGroupLoading,
          deleteRecipientsGroupActionData = _props5.deleteRecipientsGroupActionData,
          setRecipientsDownloadLoading = _props5.setRecipientsDownloadLoading;
      var _state = this.state,
          groupCollapsers = _state.groupCollapsers,
          allSelected = _state.allSelected;


      return _react2.default.createElement(
        'div',
        { className: className },
        !(hideEmpty && (0, _isEmpty3.default)(recipientsGroupedList)) && _react2.default.createElement(
          'div',
          { className: styles.list },
          _react2.default.createElement(
            'div',
            { className: styles.recipientRow },
            _react2.default.createElement(
              'div',
              { className: styles.idColumn },
              t('Id')
            ),
            _react2.default.createElement(
              'div',
              { className: styles.nameColumn },
              t('Recipient')
            ),
            individualExpiryDate && _react2.default.createElement(
              'div',
              { className: styles.dateColumn },
              t('Expiry date')
            ),
            downloadAuthorised && _react2.default.createElement(
              'div',
              { className: styles.authColumn },
              t('Download'),
              _react2.default.createElement(
                'span',
                { className: 'pos-rel margin-left-5' },
                _react2.default.createElement(_Checkbox2.default, { checked: allSelected, onChange: this.toggleSelectAll }),
                _react2.default.createElement(_index.Loader, { show: setRecipientsDownloadLoading, mask: true, small: true })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.statusColumn },
              t('Status')
            ),
            _react2.default.createElement('div', { className: styles.actionsColumn })
          ),
          recipientsGroupedList.map(function (recipient) {
            return recipient.groupId ? _react2.default.createElement(
              'div',
              { key: recipient.groupId, className: styles.groupContainer },
              _react2.default.createElement(_ProjectRecipientsListGroupItem2.default, {
                onClick: _this2.toggleGroup,
                group: recipient,
                individualExpiryDate: individualExpiryDate,
                downloadAuthorised: downloadAuthorised,
                loading: deleteRecipientsGroupLoading && deleteRecipientsGroupActionData.groupId === recipient.groupId,
                onDelete: _this2.deleteGroup
              }),
              groupCollapsers[recipient.groupId] && recipient.recipients.map(function (groupRecipient) {
                return _react2.default.createElement(_ProjectRecipientsListItem2.default, {
                  key: groupRecipient.recipientId,
                  recipient: groupRecipient,
                  className: styles.groupRecipientRow,
                  individualExpiryDate: individualExpiryDate,
                  downloadAuthorised: downloadAuthorised,
                  loadingEditRecipient: loadingEditRecipient,
                  loading: deleteRecipientLoading && deleteRecipientActionData.recipientId === groupRecipient.recipientId,
                  onDelete: _this2.deleteRecipient,
                  onUpdateDownload: _this2.updateRecipientDownload,
                  onUpdateExpirationDate: _this2.updateRecipientExpirationDate
                });
              })
            ) : _react2.default.createElement(_ProjectRecipientsListItem2.default, {
              key: recipient.recipientId,
              recipient: recipient,
              individualExpiryDate: individualExpiryDate,
              downloadAuthorised: downloadAuthorised,
              loadingEditRecipient: loadingEditRecipient,
              loading: deleteRecipientLoading && deleteRecipientActionData.recipientId === recipient.recipientId,
              onDelete: _this2.deleteRecipient,
              onUpdateDownload: _this2.updateRecipientDownload,
              onUpdateExpirationDate: _this2.updateRecipientExpirationDate
            });
          })
        ),
        recipientsListLoading && _react2.default.createElement(_index.Loader, null)
      );
    }
  }]);
  return ProjectRecipientsList;
}(_react.Component), _class3.propTypes = {
  className: _propTypes2.default.string,
  deleteRecipient: _propTypes2.default.func,
  deleteRecipientActionData: _propTypes2.default.object,
  deleteRecipientLoading: _propTypes2.default.bool,
  deleteRecipientsGroup: _propTypes2.default.func,
  deleteRecipientsGroupActionData: _propTypes2.default.object,
  deleteRecipientsGroupLoading: _propTypes2.default.bool,
  downloadAuthorised: _propTypes2.default.bool,
  editRecipient: _propTypes2.default.func,
  hideEmpty: _propTypes2.default.bool,
  individualExpiryDate: _propTypes2.default.bool,
  loadingEditRecipient: _propTypes2.default.object,
  projectId: _propTypes2.default.number,
  recipientsGroupedList: _propTypes2.default.array,
  recipientsList: _propTypes2.default.array,
  recipientsListLoading: _propTypes2.default.bool,
  setRecipientsDownload: _propTypes2.default.func,
  setRecipientsDownloadLoading: _propTypes2.default.bool,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'toggleSelectAll', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleSelectAll'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteRecipient', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteRecipient'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteGroup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteGroup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateRecipient', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateRecipient'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateRecipientDownload', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateRecipientDownload'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateRecipientExpirationDate', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateRecipientExpirationDate'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleGroup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleGroup'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = ProjectRecipientsList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipients/ProjectRecipientsList/ProjectRecipientsList.js
// module id = 2087
// module chunks = 1